import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const PasswordMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Password extends Clazz {
    @Input()
    password: boolean = false;

    @Output()
    public passwordChange = new EventEmitter<boolean>();
  }

  return Password;
};

export const PasswordMixinInputs = ["password"];
